//@flow
import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';

import getImageSizeParam from '../helpers/getImageSizeParam';

import styles from './PhotoContainer.scss';

import PhotoArrowOverlay from './PhotoArrowOverlay';
import PositionIndicatorOverlay from './PositionIndicatorOverlay';
import { SocialIconOverlay } from './SocialIconOverlay';
import { ItemTagOverlay } from './ItemTagOverlay';

import type { PhotoContainer_tradePhoto as TradePhoto } from './__generated__/PhotoContainer_tradePhoto.graphql';
import type { PhotoContainer_photoQuery as TradePhotosQueryOutput } from './__generated__/PhotoContainer_photoQuery.graphql';
import type { ProjectPhoto } from '../InteriorPhotoWrapper';

export type PhotoContainerProps = {
    tradePhoto?: TradePhoto | null,
    photoQuery: ?TradePhotosQueryOutput,
    pageChange: string => void,
    photos: Array<?ProjectPhoto>,
};

type PhotoContainerState = {
    photoIndex: number,
    photoCount: number,
    height: number,
    width: number,
};

export class PhotoContainerComponent extends Component<PhotoContainerProps, PhotoContainerState> {
    constructor() {
        super();

        this.state = {
            photoIndex: 0,
            photoCount: 0,
            width: 0,
            height: 0,
        };

        this.image = React.createRef();
        this.containerElement = React.createRef();
    }

    static getDerivedStateFromProps(
        nextProps: PhotoContainerProps,
        prevState: PhotoContainerState
    ): PhotoContainerState {
        const photoId = parseInt(
            getter(nextProps)
                .at('tradePhoto')
                .value('serviceId') || 0
        );

        const photoIndex = nextProps.photos.findIndex(photo => {
            const serviceId = getter(photo).value('serviceId');
            if (!serviceId) {
                return false;
            }
            return parseInt(serviceId) === photoId;
        });
        const photoCount = nextProps.photos.length;

        const output = {
            ...prevState,
            photoIndex,
            photoCount,
        };

        return output;
    }

    image: any;

    render() {
        const getProps = getter(this.props);

        const tradePhoto = getProps.value('tradePhoto') || null;
        const photoPath = getProps.at('tradePhoto').value('path');

        if (!photoPath) {
            return null;
        }

        const qualifiedPhotoPath = `${photoPath}${getImageSizeParam(getProps.value('tradePhoto'))}`;

        return (
            <div className={styles.container} ref={this.containerElement}>
                <div className={styles.imageLayoutWrapper}>
                    {/* always visible */}
                    <div className={styles.imageCoverageWrapper}>
                        <img src={qualifiedPhotoPath} className={styles.img} ref={this.image} />
                        <PositionIndicatorOverlay
                            currentPhotoIndex={this.state.photoIndex}
                            photoCount={this.state.photoCount}
                        />
                    </div>
                    {/* visible on hover only */}
                    <div className={styles.overlay}>
                        <SocialIconOverlay
                            photo={(tradePhoto || {}: Object)}
                            photoQuery={(this.props.photoQuery || {}: Object)}
                        />
                        <PhotoArrowOverlay
                            photoCount={this.state.photoCount}
                            photoIndex={this.state.photoIndex}
                            photos={this.props.photos}
                            pageChange={this.props.pageChange}
                        />
                        <ItemTagOverlay
                            tradePhoto={(tradePhoto: ?Object)}
                            height={this.state.height}
                            width={this.state.width}
                            photoRef={this.image}
                            containerRef={this.containerElement}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const PhotoContainer = createFragmentContainer(PhotoContainerComponent, {
    photoQuery: graphql`
        fragment PhotoContainer_photoQuery on TradePhotosQueryOutput {
            ...SocialIconOverlay_photoQuery
        }
    `,
    tradePhoto: graphql`
        fragment PhotoContainer_tradePhoto on TradePhoto {
            ...ItemTagOverlay_tradePhoto
            ...SocialIconOverlay_photo
            path
            height
            width
            serviceId
        }
    `,
});
